import {
  Header,
  HeroSection,
  FeatureSection,
  HowItWorksSection,
  VideoExamplesSection,
  PricingSection,
  FAQSection,
  Footer,
  CallToActionSection,
} from "./components";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { SplitText } from "gsap/SplitText";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { useGSAP } from '@gsap/react';
import { cn } from "@/lib/utils";
import { useSearchParams } from "react-router-dom";

gsap.registerPlugin(
  useGSAP, 
  ScrollTrigger, 
  ScrollSmoother, 
  ScrollToPlugin,
  SplitText
);

function LandingPage() {
  const [searchParams] = useSearchParams();

  useGSAP(() => {
    const smoother = ScrollSmoother.create({
      smooth: 1,
      effects: true,
    });

    const section = searchParams.get("section");
    if (section) {
      requestAnimationFrame(() => {
        setTimeout(() => {
          smoother.scrollTo(`#${section}`, true);
        }, 500);
      });
    }
  });
  
  return (
    <div id="smooth-wrapper">
      <div id="smooth-content" className="bg-lavender-light w-full">
        <div className={cn(
          "flex flex-col min-h-screen max-w-7xl mx-auto",
          "2k:max-w-[74%]",
          "4k:max-w-[80%]"
        )}>
          <Header />
          <main>
            {/* <HeroSection /> */}
            <CallToActionSection />
            <FeatureSection />
            <HowItWorksSection />
            <VideoExamplesSection />
            <PricingSection />
            <FAQSection />
          </main>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export { LandingPage };
